import get from 'lodash/get';
import find from 'lodash/find';
import { createSelector } from 'reselect';
import METHOD_PRIORITY from '../../utils/fulfillmentMethodPriority';
import { getStoreProductDetails } from '../../selectors';

/**
 * Whenever the user selects a choice and we get a new
 * product (with new fulfillment data) we need to
 * determine what the selected method should be.
 */
const getNextFulfillmentMethod = createSelector(
  (state) => state.cart.fulfillmentMethod,
  getStoreProductDetails,
  (currentMethod, storeProduct) => {
    const fo = storeProduct.fulfillmentOptions || {};

    if (!fo.fulfillable) {
      return null;
    }

    if (fo[currentMethod]) {
      return currentMethod;
    }

    return find(
      METHOD_PRIORITY,
      (method) => get(fo[method], 'status'),
    );
  },
);

export default getNextFulfillmentMethod;
